import React, { useContext } from 'react';
import '../css/LanguageLoader.css';
import { LocalizationContext } from '../localization/LocalizationContext';

const LanguageLoader = () => {
  const { translations } = useContext(LocalizationContext);
  return (
    <div className="language-loader-overlay">
      <div className="language-loader-container">
        <div className="language-loader-spinner"></div>
        <p className="language-loader-text">{translations?.common?.loading || 'Loading...'}</p>
      </div>
    </div>
  );
};

export default LanguageLoader;
